/**
 * Subscribe/notify plus a snapshot cache for `useSyncExternalStore` over
 * storage; `stable` reuses a slot's previous reference while its value is equal.
 */
export const createExternalStore = <T>() => {
  const listeners = new Set<() => void>();
  const cache = new Map<string, { serialized: string; value: T }>();

  const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  };

  const notify = () => listeners.forEach((listener) => listener());

  const stable = (value: T, slot = ''): T => {
    const serialized = JSON.stringify(value ?? null);
    const hit = cache.get(slot);

    if (hit?.serialized === serialized) return hit.value;

    cache.set(slot, { serialized, value });
    return value;
  };

  return { notify, stable, subscribe };
};
